// React
import React from 'react';
import config from 'config';
import {Link} from 'react-router-dom';
import appRouter from '../../utils/appRouter';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';

import Utils from '../../utils/utils';

import MenuApi from '../../api/menu-api';
import GameApi from '../../api/game-api';
import UserApi from '../../api/user-api';

class MainMenu extends React.Component {
	constructor(props) {
		super(props);
	}

	isPath(path) {
		let regex = new RegExp('/' + path);
		return regex.test(this.props.location.pathname);
	}

	render() {
		let menuArr = config.application.mainMenu;
		let hasPlan = UserApi.hasPlanActive(this.props.user);
		let hasTickets = GameApi.countTickets(this.props.user.game);
		
		let self = this;
		return (
			<div>
			{this.props.menu.state &&
				<div className="page-closeMenu" onClick={()=>{MenuApi.toggleMenu(false)}}></div>
			}

			<ul className="nav nav-underline navbar-nav pull-right">
				<li className="glyphicon glyphicon-remove" onClick={()=>{MenuApi.toggleMenu(false)}}> </li>
				{menuArr && menuArr.map((item, i) =>

					<li className={(self.isPath(item) ? 'active ' : '')} key={i} onClick={()=>{MenuApi.toggleMenu(false)}}>
						<Link to={appRouter.getLink(item)} onClick={()=>{
							if (item == 'game') Utils.gaSend('Assinatura', 'Menu Superior', 'Jogar');
							appRouter.gaPageView(item);
						}}>
							<FormattedMessage id={"header.menu." + item}/>

							{(item === 'tickets') && (hasTickets != 0) &&
								<span className="text-bold"> (
									{GameApi.countTickets(this.props.user.game)}
								)</span>
							}

							{(item === 'game') && hasPlan &&
								<span className="questions">
									{this.props.user.game.questionsAvailable}
									{(!this.props.user.msisdn || !this.props.user.game) && "0"}
								</span>
							}
						</Link>
					</li>
				)}
			</ul>
			</div>
		)
	}
}

const mapStateToProps = function (store) {
	return {
		location: store.locationState.location,
		user: store.userState,
		menu: store.menuState
	};
};

export default connect(mapStateToProps)(MainMenu);


// WEBPACK FOOTER //
// ./src/components/core/mainMenu.component.jsx